import React, { Component, Fragment } from 'react';
import TmDateTimePicker from '../../utilComponents/tmDateTimePicker/tmDateTimePicker';
import { GlobalValues } from '../../../util/constants.js';
import moment from 'moment';
import Form from 'react-validation/build/form';
import {
    required
} from "../../../util/validationMethods.js";
class CustomPDAllTowsCtrl extends Component {
	constructor() {
		super();
		this.state = {
			
		}
    }
    render() {
		return (
            <Fragment>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card form-group">
                                <div className="card-body pd-10">
                                    <Form ref={c => {
                                        this.formCustomPDAllTowsInfo = c;
                                        this.props.initCallBack(c);
                                    }}>
                                    <div className="form-row form-group">
                                        <div className="col-sm-2">
                                            <div className="custom-control custom-checkbox mb-5 mr-2">
                                                <input className="custom-control-input"
                                                    id="inlineCheckboxPrecinct4"
                                                    type="checkbox"
                                                    name="Precinct4"
                                                    value=""
                                                />
                                                <label className="custom-control-label" htmlFor="inlineCheckboxPrecinct4">Precinct 4</label>
                                            </div>
                                        </div>

                                        <div className="col-sm-2">
                                            <div className="custom-control custom-checkbox mb-5 mr-2">
                                                <input className="custom-control-input"
                                                    id="inlineCheckboxPrecinct5"
                                                    type="checkbox"
                                                    name="Precinct5"
                                                    value=""
                                                />
                                                <label className="custom-control-label" htmlFor="inlineCheckboxPrecinct5">Precinct 5</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="custom-control custom-checkbox mb-5 mr-2">
                                                <input className="custom-control-input"
                                                    id="inlineCheckboxPrecinct6"
                                                    type="checkbox"
                                                    name="Precinct6"
                                                    value=""
                                                />
                                                <label className="custom-control-label" htmlFor="inlineCheckboxPrecinct6">Precinct 6</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="custom-control custom-checkbox mb-5 mr-2">
                                                <input className="custom-control-input"
                                                    id="inlineCheckboxPrecinct7"
                                                    type="checkbox"
                                                    name="Precinct7"
                                                    value=""
                                                />
                                                <label className="custom-control-label" htmlFor="inlineCheckboxPrecinct7">Precinct 7</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        {/* <div className="ml-2 mr-2 form-group">
                                            <label htmlFor="account" className="form-label col-form-label mr-2">Account</label>
                                        </div> */}
                                        <div className="col-2 form-group">
                                            <input type="text" className="form-control" placeholder="Account Name"
                                                name="accountName" value={''}
                                            />
                                        </div>
                                        <div className="ml-2 mr-2 form-group">
                                            <label htmlFor="from" className="form-label col-form-label mr-2">From</label>
                                        </div>
                                        <div className="col-2 form-group">
                                        <div>
                                        <TmDateTimePicker
                                        className="form-control"
                                        selectedDate={
                                            this.props.fromdate === "" || this.props.fromdate === null
                                                ? null
                                                : moment(
                                                    this.props.fromdate,
                                                    GlobalValues.dateFormat
                                                )._d
                                        }
                                        dateFormat={GlobalValues.dateFormat}
                                        validationArray={[required]}
                                        showYearDropdown={true}
                                        showmonthdropdown={true}
                                        name="fromDate"
                                        reqmsg="From date is required"
                                        onDateSelectChange={e => {
                                            this.props.onCustomPDAllTowsFieldChange('fromDate', e === null ? '' : moment(e).format(GlobalValues.dateFormat))
                                            this.forceUpdate()
                                        }} 
                                    />
                                    </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="to" className="form-label col-form-label mr-2">To</label>
                                        </div>
                                        <div className="col-2 form-group">
                                        <div>
                                        <TmDateTimePicker
                                        className="form-control"
                                        selectedDate={
                                            this.props.todate === "" || this.props.todate === null
                                                ? null
                                                : moment(
                                                    this.props.todate,
                                                    GlobalValues.dateFormat
                                                )._d
                                        }
                                        dateFormat={GlobalValues.dateFormat}
                                        validationArray={[required]}
                                        showYearDropdown={true}
                                        showmonthdropdown={true}
                                        name="toDate"
                                        reqmsg="To date is required"
                                        onDateSelectChange={e => {
                                            this.props.onCustomPDAllTowsFieldChange('toDate', e === null ? '' : moment(e).format(GlobalValues.dateFormat))
                                            this.forceUpdate()
                                        }} 
                                    />
                                    </div>
                                        </div>

                                        <div className="col-5 form-group">                                   
                                            <button type="button" className="btn btn-success custom-reports-btn mr-2" 
                                            >Go</button>
                                            <button type="button" className="btn btn-warning custom-reports-btn mr-2" >Export</button>
                                            <button type="button" className="btn btn-primary custom-reports-btn mr-2" >Email</button>
                                            <button type="button" className="btn btn-success custom-reports-btn mr-2" >Print</button>                                   
                                    </div>
                                    </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>       
            </Fragment>
        );
    }
}
export default CustomPDAllTowsCtrl;